"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = exports.DirectInsertPortfolioCovenantsConfigSchema = void 0;
const zod_1 = require("zod");
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.DirectInsertPortfolioCovenantsConfigSchema = zod_1.z.object({
    portfolioCovenantsArtifactSlug: zod_1.z
        .string()
        .describe('CSV with the format described by `format`'),
    format: zod_1.z
        .enum(['columnPerEntry', 'rowPerEntry'])
        .describe('Describes the input CSV format.\n\n`columnPerEntry`: this is the output of performing an `extractValues` on an Excel file. It is a CSV with a header row and exactly one data row. Each column name should match its respective `portfolioCovenantKey`.\n\n`rowPerEntry`: this format is more useful if accepting a CSV upload directly from a customer. This should have exactly two columns called `portfolioCovenantKey` and `value`.\n\nThe value must be of type `float`.'),
    portfolioCovenantKeys: zod_1.z
        .array(zod_1.z.string())
        .min(1)
        .describe('List of keys that we expect to extract from this tape.\n\nIf a key is missing from the tape, an error will be reported. If a key is present in the tape but missing here, it will be ignored.'),
});
exports.UIConfigSchema = zod_1.z
    .object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: zod_1.z.string().describe('Credit facility slug'),
})
    .merge(exports.DirectInsertPortfolioCovenantsConfigSchema);
exports.nodeType = 'file_directInsertPortfolioCovenants';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
    creditFacilitySlug: true,
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'directInsertPortfolioCovenants';
//# sourceMappingURL=types.js.map